// EditItemLineDialog.js - Dialog for editing item lines
import { useState, useEffect } from 'react';
import '../newCustomerDialog.css';
import { authFetchRequest, getCookie } from './AppearanceCommon';

const EditItemLineDialog = ({ show, data, onClose, onSave }) => {
  const [formData, setFormData] = useState(data || {});

  useEffect(() => {
    if (data) setFormData(data);
  }, [data]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.id) {
      alert('Item Line ID is missing!');
      return;
    }

    try {
      const updatedItem = await authFetchRequest(
        `/appearance-templates/${formData.id}`,
        formData,
        'PUT',
        { Authorization: `Bearer ${getCookie("access_token")}` }
      );

      onSave?.(updatedItem);
    } catch (error) {
      console.error('Error updating item line:', error);
      alert('Failed to update item line: ' + (error.message || 'Unknown error'));
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <h2>Edit Item Line Setup</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group-dialog">
            <label>ID: <strong>{formData.id}</strong> (cannot change)</label>
          </div>

           {/* ROW 1: Product Type + Label */}
           <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', alignItems: 'end' }}>
            <div style={{ flex: '0 0 23%' }}>
              <label>Product Type:</label>
              <input
                type="text"
                name="product_type"
                value={formData.product_type || ''}
                onChange={handleChange}
                style={{ width: '100%' }}
                required
              />
            </div>
            <div style={{ flex: 1 }}>
              <label>Label:</label>
              <input
                type="text"
                name="label"
                value={formData.label || ''}
                onChange={handleChange}
                style={{ width: '100%' }}
              />
            </div>
          </div>

          {/* ROW 2: Topic + Topic # + Q # + Order + Active */}
          <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', alignItems: 'end' }}>
            <div style={{ flex: '0 0 300px' }}>
              <label>Topic:</label>
              <input
                type="text"
                name="topic"
                value={formData.topic || ''}
                onChange={handleChange}
                placeholder="e.g. Main, Glass"
                style={{ width: '100%' }}
              />
            </div>
            <div style={{ flex: '0 0 70px' }}>
              <label>Topic #:</label>
              <input
                type="number"
                name="topic_number"
                value={formData.topic_number ?? ''}
                onChange={handleChange}
                min="0"
                style={{ width: '100%' }}
              />
            </div>
            <div style={{ flex: '0 0 70px' }}>
              <label>Q #:</label>
              <input
                type="number"
                name="q_number"
                value={formData.q_number ?? ''}
                onChange={handleChange}
                min="0"
                style={{ width: '100%' }}
              />
            </div>
            <div style={{ flex: '0 0 70px' }}>
              <label>Order:</label>
              <input
                type="number"
                name="order_place"
                value={formData.order_place || ''}
                onChange={handleChange}
                min="0"
                style={{ width: '100%' }}
              />
            </div>
            <div style={{ flex: '0 0 80px', display: 'flex', alignItems: 'center', paddingBottom: '8px' }}>
              <label className="label-checkbox" style={{ margin: 0 }}>
                <input
                  type="checkbox"
                  name="active"
                  checked={formData.active || false}
                  onChange={handleChange}
                />
                Active
              </label>
            </div>
          </div>

          <div className="form-group-dialog">
            <label>
              Description:
              <textarea
                name="description"
                value={formData.description || ''}
                onChange={handleChange}
                rows="2"
              />
            </label>
          </div>

          <div className="form-group-dialog">
            <label>
              Condition:
              <textarea
                name="condition"
                value={formData.condition || ''}
                onChange={handleChange}
                rows="3"
              />
            </label>
          </div>

          <div className="form-group-dialog">
            <label>
              Template:
              <textarea
                name="template"
                value={formData.template || ''}
                onChange={handleChange}
                rows="5"
              />
            </label>
          </div>

          <div className="form-group-dialog">
            <label>
              Expressions:
              <textarea
                name="expressions"
                value={
                    typeof formData.expressions === 'object' && formData.expressions !== null
                      ? JSON.stringify(formData.expressions, null, 2)
                      : String(formData.expressions || '')
                  }
                onChange={handleChange}
                rows="4"
              />
            </label>
          </div>

          <div className="form-actions">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit">Save Changes</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditItemLineDialog;
